import { AdminType, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { ICustomer } from "redux/reducers/models/customer";

export interface IGetPortalAccommodationReservation {
  id?: number;
  with_customer?: true;
  with_units?: boolean;
  start_date?: string;
  end_date?: string;
}

export interface IPostPortalAccommodationReservation {
  customer_id: number;
  unit_type_id: number;
  arrival_date: string;
  departure_date: string;
  currency: string;
  adults: number;
  children: number;
  quoted_total_amount: number;
  customer?: ICustomer;
  payment_method_id: number;
  nightly_rates: number[];
  facility_id: number;
  nights: number;
  terms_accepted: boolean;
  newsletter_accepted: boolean;
  note?: string;
  cart_token?: string;
}

export interface IPostPortalAccommodationCart {
  facility_id: number;
  nightly_rates: number[];
}

interface IPutAccommodationReservation {
  id: number;
  title: string;
  unit_category_id: number;
  base_occupancy: number;
  max_occupancy: number;
}

// GET Accommodation Reservations
export async function GetAccommodationReservations(params: IGetPortalAccommodationReservation, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.Customer, "/accommodation/reservation"), params, useGlobalLoader);
}

// POST Accommodation Reservations
export async function PostAccommodationReservation(params: IPostPortalAccommodationReservation, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.Customer, "/accommodation/reservation"), params, useGlobalLoader);
}

export async function PostAccommodationCart(params: IPostPortalAccommodationCart, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.Customer, "/accommodation/cart"), params, useGlobalLoader);
}
// PUT Accommodation Reservations
export async function PutAccommodationReservation(params: IPutAccommodationReservation, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.Customer, "/accommodation/reservation"), params, useGlobalLoader);
}
